import { ReactSVG } from "react-svg";

const GlobalLoading = () => {
  return (
    <>
      <div className="z-2 top-0 bg-gradient-to-br from-slate-700 to-slate-900 right-0 bottom-0 left-0 absolute flex flex-col justify-center place-items-center">
        <ReactSVG src={'../../assets/mvsf-spinner-white.svg'} className="mx-auto h-12 w-auto" />
      </div>
    </>
  );
};

export default GlobalLoading;
